import React, { FC, useEffect, useState } from "react";
import "./leaderboard.scss";
import { deserialize } from "serializr";
import { Col, Progress, Row, Select } from "antd"
import RankBoard from "./RankBoard";
import CurrentStudentRank from "./CurrentStudentRank";
import PointsHistory from "./PointsHistory";
import { useLocation } from "react-router-dom";
//model
import { MetaModel } from "../../../../models/CourseModels/SubjectModel/subject.model";
import { Students } from "../../../../models/InstituteModel/students.model";
import { InstituteLeaderboard as InstituteLeaderboardModel } from "../../../../models/InstituteModel/leaderboard.model";

//service
import { SubscriptionsService } from "../../../../services/SubscriptionService/subscription.service";
import { StudentLeaderboardService } from "../../../../services/StudentService/leaderboard.service";


const InstituteLeaderboard: FC = () => {
  const [leaderboard, setLeaderboard] = useState<InstituteLeaderboardModel>({});
  const { state }: { state: Students } = useLocation();
  const [loading, setLoading] = useState<boolean>(true);

  const [classRooms, setClassRooms] = useState<MetaModel[]>([]);
  const [currentClassRooms, setCurrentClassRooms] = useState<any>();

  const fetchSubscriptions = () => {
    if (state?.id) {
      setLoading(true)
      SubscriptionsService.fetchSubscriptions(
        state?.id,
        (data) => {
          const meta = deserialize(MetaModel, data) as MetaModel[];
          setClassRooms(meta);
          if (meta.length) {
            let value = Number(meta[0].value)
            setCurrentClassRooms(value)
          }
        },
        () => { },
        () => {
          setLoading(false);
        }
      );
    }
  };

  const fetchLeaderboardData = () => {
    if (state?.id)
      StudentLeaderboardService?.fetchLeaderboardData(
        { CourseId: currentClassRooms, StudentId: state?.id },
        (data) => {
          setLeaderboard(data);
        },
        () => { },
        () => { setLoading(false) }
      );
  };

  useEffect(() => {
    fetchSubscriptions();
  }, [state]);

 
  useEffect(() => {
    if (currentClassRooms !== undefined) {
      fetchLeaderboardData();
    }
  }, [ currentClassRooms]);


  return (
    <div className="institute-leaderboard">
      <div className="institute-leaderboard__header">
        <Row className="mlp-3" >
          <Col span={6}>
            <div className="analytics-rank__container">
              <Select
                value={currentClassRooms}
                className="course__dropdown"
                placeholder="Select course"
                options={classRooms}
                onChange={(value) => {
                  console.log(value);

                  setCurrentClassRooms(value);
                }}
              />
              {/* <div className="analytics__rank">Rank 04</div> */}
            </div>
          </Col>
        </Row>
        <RankBoard data={leaderboard} loading={loading} />
        <CurrentStudentRank data={leaderboard} loading={loading} />
      </div>

      <PointsHistory data={leaderboard} loading={loading} />
    </div>
  );
};

export default InstituteLeaderboard;
